<template>
  <div>
    <!-- Top Info Grid -->
    <section class="top-info py-2">
      <b-container>
        <b-row class="text-center align-items-center">
          <b-col md="4" class="info-item">
            <strong>Our Office</strong><br />
            <small>laaga rd 4 elepe ikorodu, Lagos stste</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Email Us</strong><br />
            <small>olaleresomod24@gmail.com</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Contact Us</strong><br />
            <small>+234 800 123 4567</small>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- NAVBAR -->
    <b-navbar toggleable="lg" type="dark" variant="dark" class="bg-dark">
      <b-navbar-brand to="/">JEWELUX</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/shop">Shop</b-nav-item>
          <b-nav-item to="/about">About Us</b-nav-item>
          <b-nav-item to="/partners">Partners</b-nav-item>
          <b-nav-item to="/contact">contacts</b-nav-item>
          <b-nav-item to="/cart">cart</b-nav-item>
        </b-navbar-nav>


      </b-collapse>
    </b-navbar>



    <!-- HERO SECTION -->
    <section class="hero text-white text-center">
      <img class="img testimonial-img" src="../assets/about.jpg" />
      <div class="overlay">
        <h1>Luxury Jewellery</h1>
        <p>Timeless elegance crafted for you</p>
      </div>
    </section>

    <!-- ABOUT US SECTION -->
    <section class="container py-5">
      <div class="row align-items-center">
        <div class="col-md-6">
          <img class="img testimonial-img" src="../assets/person_1.jpg" />
        </div>
        <div class="col-md-6">
          <h2>About Us</h2>
          <p>
            JEWELUX began with a passion for crafting exquisite jewellery pieces.
            Our mission is to create timeless designs that blend elegance and quality.
          </p>
        </div>
      </div>
    </section>



    <!-- PRODUCTS SECTION WITHOUT V-FOR -->
    <section class="container py-5">
      <h2 class="text-center mb-4">Our Products</h2>
      <b-row>
        <b-col md="3" class="mb-4">
          <b-card class="text-center h-100">
            <img class="img testimonial-img" src="../assets/diamond.jpg" />
            <h6 class="mt-3">Diamond Ring</h6>
            <p>$800</p>
            <b-button size="sm" variant="dark"
              @click="addToCart({ id: 1, name: 'Diamond Ring', price: 800, img: '../assets/person_1.jpg' })">
              Add to Cart
            </b-button>
          </b-card>
        </b-col>
        <b-col md="3" class="mb-4">
          <b-card class="text-center h-100">
            <img class="img testimonial-img" src="../assets/goldnec.jpg" />
            <h6 class="mt-3">Gold Necklace</h6>
            <p>$650</p>
            <b-button size="sm" variant="dark"
              @click="addToCart({ id: 2, name: 'Gold Necklace', price: 650, img: '../assets/person_1.jpg' })">
              Add to Cart
            </b-button>
          </b-card>
        </b-col>
        <b-col md="3" class="mb-4">
          <b-card class="text-center h-100">
            <img class="img testimonial-img" src="../assets/silver.jpg" />
            <h6 class="mt-3">Silver Bracelet</h6>
            <p>$300</p>
            <b-button size="sm" variant="dark"
              @click="addToCart({ id: 3, name: 'Silver Bracelet', price: 300, img: '../assets/person_1.jpg' })">
              Add to Cart
            </b-button>
          </b-card>
        </b-col>
        <b-col md="3" class="mb-4">
          <b-card class="text-center h-100">
            <img class="img testimonial-img" src="../assets/earrings.jpg" />
            <h6 class="mt-3">Pearl Earrings</h6>
            <p>$450</p>
            <b-button size="sm" variant="dark"
              @click="addToCart({ id: 4, name: 'Pearl Earrings', price: 450, img: '../assets/person_1.jpg' })">
              Add to Cart
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </section>



    <!-- DEAL OF THE DAY -->
    <section class="deal text-white text-center">
      <img class="img testimonial-img" src="../assets/image_1.jpg" />
      <div class="overlay">
        <h2>Deal of the Day</h2>
        <p>Get 25% off selected items today!</p>
      </div>
    </section>

    <!-- PARTNERS SECTION WITHOUT V-FOR -->
    <section class="container py-5">
      <h2 class="text-center mb-4">Our Trusted Partners</h2>
      <b-row>
        <b-col md="3" class="mb-4">
          <img class="img testimonial-img" src="../assets/buhari.jpg" />
        </b-col>
        <b-col md="3" class="mb-4">
          <img class="img testimonial-img" src="../assets/shet.jpg" />
        </b-col>
        <b-col md="3" class="mb-4">
          <img class="img testimonial-img" src="../assets/atiku.jpg" />
        </b-col>
        <b-col md="3" class="mb-4">
          <img class="img testimonial-img" src="../assets/sanwo.jpg" />
        </b-col>
      </b-row>
    </section>

    <section class="partners-say py-5">
      <b-container>
        <!-- Section Header -->
        <div class="text-center mb-5">
          <h2 class="fw-bold">What Our Partners Say</h2>
          <p class="text-muted">
            Hear from the partners who trust our brand and products
          </p>
        </div>

        <!-- Testimonials -->
        <b-row>
          <b-col md="4" class="mb-4">
            <b-card class="h-100 text-center shadow-sm">
              <p class="testimonial-text">
                “This brand consistently delivers high-quality jewelry and
                outstanding customer service. Our partnership has been
                very successful.”
              </p>
              <hr />
              <h6 class="fw-bold mb-0">president Bola Ahmed Tinubu</h6>
              <small class="text-muted">Luxury Brand Partner</small>
            </b-card>
          </b-col>

          <b-col md="4" class="mb-4">
            <b-card class="h-100 text-center shadow-sm">
              <p class="testimonial-text">
                “Professional, reliable, and creative. Their designs always
                impress our customers and help grow our business.”
              </p>
              <hr />
              <h6 class="fw-bold mb-0">karim shettima</h6>
              <small class="text-muted">Luxury Brand Partner</small>
            </b-card>
          </b-col>

          <b-col md="4" class="mb-4">
            <b-card class="h-100 text-center shadow-sm">
              <p class="testimonial-text">
                “A trusted partner we can always rely on. Quality products
                and excellent communication make collaboration easy.”
              </p>
              <hr />
              <h6 class="fw-bold mb-0">Governor Babatunde Sanwoolu</h6>
              <small class="text-muted">Luxury Brand Partner</small>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <!-- Modern Footer -->
    <b-container fluid class="bg-dark text-white pt-5 pb-3">
      <b-row class="text-center text-md-left">

        <!-- Brand / Logo -->
        <b-col md="3" class="mb-4">
          <h4 class="text-gold font-weight-bold">JEWELUX</h4>
          <p class="small">Luxury handcrafted jewelry for every occasion.</p>
        </b-col>

        <!-- Quick Links -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Quick Links</h5>
          <ul class="list-unstyled">
            <li><a href="#" class="text-white">Home</a></li>
            <li><a href="#" class="text-white">Shop</a></li>
            <li><a href="#" class="text-white">About</a></li>
            <li><a href="#" class="text-white">Contact</a></li>
          </ul>
        </b-col>

        <!-- Social Media -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Follow Us</h5>
          <div>
            <b-icon icon="facebook" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="instagram" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="twitter" font-scale="1.5" class="mr-2 text-white"></b-icon>
          </div>
        </b-col>

        <!-- Newsletter -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Newsletter</h5>
          <b-form @submit.prevent="subscribe">
            <b-input-group size="sm">
              <b-form-input v-model="email" type="email" placeholder="Your email" required></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="gold">Subscribe</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col class="text-center small">
          &copy; 2026 JEWELUX. All rights reserved.
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'IndexPageNoVfor',
  methods: {
    addToCart(product) {
      let cart = JSON.parse(localStorage.getItem('cart')) || []
      const existing = cart.find(item => item.id === product.id)
      if (existing) {
        existing.qty += 1
      } else {
        cart.push({ ...product, qty: 1 })
      }
      localStorage.setItem('cart', JSON.stringify(cart))
      alert(`${product.name} added to cart!`)
    }
  }
}
</script>

<style scoped>
.hero,
.deal {
  position: relative;
  height: 60vh;
}

.hero img,
.deal img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-text {
  font-style: italic;
  color: #555;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bg-black {
  background-color: #000;
}

.img {
  width: 100%;
  border-radius: 12px;


}



/* Footer Styling */
.text-gold {
  color: #bfa14b;
}
</style>
